export default "__VITE_ASSET__DrCpOZMy__"